import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Box, Button, IconButton, TextField, Stack, Paper, Divider, Grid2, Snackbar, Alert, Card, CardContent, CardHeader, Typography } from "@mui/material";
import AsyncButton from "../../components/common/AsyncButton";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell, StyledTableRow } from '../../theme';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { InvokeAPI } from "../../apis/API";
import { getUserMgmtBase } from "../../config/apiBase";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { ContentCopy, MailOutline, Link as LinkIcon, Person } from "@mui/icons-material";


/*
<TextField
                    fullWidth
                    label="Custom Message (Optional)"
                    variant="outlined"
                    multiline
                    rows={3}
                    sx={{ 
                        mb: 2,
                        '& .MuiOutlinedInput-root': {
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                transform: 'translateY(-1px)',
                            },
                        },
                    }}
                />*/

const Invite = () => {

    const { user, logout } = useAuth()
    const inviteCardRef = useRef(null);
    const referralCardRef = useRef(null);
    const referredCardRef = useRef(null);

    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const [tourOpen, setTourOpen] = useState(false);
    const [tourStep, setTourStep] = useState(0);
    const handleClose = () => {
        setState({ ...state, open: false });
    };




    const path = window.location.href.replace("/app/invite", "/signup/")

    const copyLinkToClipboard = async () => {
        await navigator.clipboard.writeText(path + user["referralCode"]);
    }
    const copyCodeToClipboard = async () => {
        await navigator.clipboard.writeText(user["referralCode"]);
    }

    const tourSteps = [
        {
            title: "Invite via Email",
            description: "Enter an email and name, then click Invite to send a direct invitation.",
            targetRef: inviteCardRef,
        },
        {
            title: "Referral Code Details",
            description: "Copy your referral code or full signup link and share it anywhere.",
            targetRef: referralCardRef,
        },
        {
            title: "People You Referred",
            description: "Track invited users and activation counts in this table.",
            targetRef: referredCardRef,
        },
    ];

    const startTour = () => {
        setTourStep(0);
        setTourOpen(true);
    };

    const closeTour = () => {
        setTourOpen(false);
    };

    const goToTourStep = (nextStep) => {
        if (nextStep < 0) return;
        if (nextStep >= tourSteps.length) {
            closeTour();
            return;
        }
        setTourStep(nextStep);
    };

    useEffect(() => {
        if (!tourOpen) return;
        const target = tourSteps[tourStep]?.targetRef?.current;
        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [tourOpen, tourStep]);




    const InviteViaEmail = () => {
        const [invite, setInvite] = useState({
            email: "",
            name: "",
        })
        const [errors, setErrors] = useState({
            email: "",
            name: "",
        });

        const handleChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target
            setInvite({ ...invite, [name]: value })
            if (errors[name]) {
                setErrors((prev) => ({ ...prev, [name]: "" }));
            }
        }
        const handleInvite = async (e) => {
            e.preventDefault();
            const trimmedEmail = (invite.email || "").trim();
            const trimmedName = (invite.name || "").trim();
            const nextErrors = { email: "", name: "" };
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!trimmedEmail) {
                nextErrors.email = "Email is required";
            } else if (!emailRegex.test(trimmedEmail)) {
                nextErrors.email = "Please enter a valid email address";
            }

            if (!trimmedName) {
                nextErrors.name = "Name is required";
            }

            if (nextErrors.email || nextErrors.name) {
                setErrors(nextErrors);
                return;
            }

            //InvokeAPI
            const status = await InvokeAPI(`${getUserMgmtBase()}/v1/user/invitation/send`,
                {
                    "EmailId": trimmedEmail,
                    "UserName": trimmedName,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (status["unauthenticated"] == true || status["unauthorized"] == true) {
                logout(user);
            }
            if (status.alreadyExists) {
                //alert("username already exists")
                setState({ open: true, severity: "warning", message: "Username already exists" })
            } else if (status.internal || status.iserror) {
                setState({ open: true, severity: "error", message: "Internal Error please try again" })
            } else {
                setState({ open: true, severity: "success", message: "User invited successfully" })
            }
        }
        return (
            <>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <MailOutline color="primary" />
                    <TextField 
                        fullWidth 
                        label="Email" 
                        type="email" 
                        variant="outlined" 
                        name="email"
                        value={invite.email}
                        onChange={handleChange}
                        required
                        autoComplete="email"
                        error={!!errors.email}
                        helperText={errors.email}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                },
                            },
                        }}
                    />
                </Box>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <Person sx={{color: "primary.main"}} />
                    <TextField 
                        fullWidth 
                        label="Name" 
                        variant="outlined" 
                        name="name"
                        value={invite.name}
                        onChange={handleChange}
                        required
                        autoComplete="name"
                        error={!!errors.name}
                        helperText={errors.name}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                },
                            },
                        }}
                    />
                </Box>
                
                <Box display="flex" justifyContent="center" sx={{ mb: 1 }}>
                    <AsyncButton 
                        variant="contained" 
                        color="primary" 
                        onClick={handleInvite}
                        sx={{
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: (theme) => theme.shadows[8],
                            },
                        }}
                    >
                        Invite
                    </AsyncButton>
                </Box>

                <Stack display={"none"}>
                    <Box sx={{ marginTop: '0px' }}>
                        <h3> Invite via Email:</h3>
                    </Box>

                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginTop: '0px' }}>
                        <Grid2 container spacing={3}>
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                <Stack>

                                    <TextField
                                        label="Email"
                                        variant="outlined"
                                        name="email"
                                        value={invite.email}
                                        onChange={handleChange}
                                        required
                                        autoComplete="true"
                                    />
                                    &nbsp;&nbsp;
                                    <TextField
                                        label="Name"
                                        variant="outlined"
                                        name="name"
                                        value={invite.name}
                                        onChange={handleChange}
                                        required
                                        autoComplete="true"
                                    />
                                    &nbsp;&nbsp;
                                </Stack>
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                <TextareaAutosize
                                    name="feedback"
                                    value="Custom Message (Optional)"
                                    minRows={9}
                                    placeholder="Your feedback is important to us!"
                                    style={{ width: "auto" }}
                                    onChange={handleChange}
                                />
                            </Grid2>



                        </Grid2>


                    </Box>
                    <AsyncButton display="flex" sx={{borderRadius: 4}} type="submit" variant="contained" color="secondary" onClick={handleInvite}>
                        Invite
                    </AsyncButton>
                </Stack>
            </>

        );
    }

    const RenderReferralCode = () => {
        return (
            <Box>
                <Paper
                    variant="outlined"
                    sx={{ 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "space-between", 
                        p: 2, 
                        mb: 2,
                        borderRadius: 2,
                        border: '1px solid',
                        borderColor: 'divider',
                        backgroundColor: 'background.paper',
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            borderColor: 'primary.main'
                        }
                    }}
                >
                    <Typography 
                        fontFamily="monospace" 
                        sx={{ 
                            fontWeight: 500,
                            fontSize: '0.95rem',
                            color: user["referralCode"] === "" ? 'text.secondary' : 'text.primary'
                        }}
                    >
                        {user["referralCode"] === "" && <>Not Generated</>}
                        {user["referralCode"] !== "" && <>{user["referralCode"]}</>}
                    </Typography>
                    <IconButton 
                        onClick={copyCodeToClipboard}
                        sx={{
                            color: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.light',
                                color: 'primary.contrastText'
                            }
                        }}
                    >
                        <ContentCopy fontSize="small" />
                    </IconButton>
                </Paper>
                <Paper
                    variant="outlined"
                    sx={{ 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "space-between", 
                        p: 2,
                        borderRadius: 2,
                        border: '1px solid',
                        borderColor: 'divider',
                        backgroundColor: 'background.paper',
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            borderColor: 'primary.main'
                        }
                    }}
                >
                    <Typography 
                        noWrap 
                        variant="body2"
                        sx={{ 
                            flex: 1,
                            mr: 1,
                            color: user["referralCode"] === "" ? 'text.secondary' : 'text.primary',
                            fontSize: '0.875rem'
                        }}
                    >
                        {user["referralCode"] === "" && <>Not Generated</>}
                        {user["referralCode"] !== "" && <>{path + user["referralCode"]}</>}
                    </Typography>
                    <IconButton 
                        onClick={copyLinkToClipboard}
                        sx={{
                            color: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.light',
                                color: 'primary.contrastText'
                            }
                        }}
                    >
                        <LinkIcon fontSize="small" />
                    </IconButton>
                </Paper>


                <Box display={"none"}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <h3>Your Referral Code Details:</h3>
                    </Box>
                    <Stack sx={{ paddingTop: "10px", paddingBottom: "10px" }}>
                        <Box>
                            <Typography variant="h8" gutterBottom>
                                <b>Code:</b>
                            </Typography>
                            <br></br>
                            {user["referralCode"] === "" && <>Not Generated</>}
                            {user["referralCode"] !== "" && <>
                                &nbsp;&nbsp;{user["referralCode"]}
                                <Button onClick={copyCodeToClipboard}><ContentCopyIcon /></Button>
                            </>}
                        </Box>
                        <br></br>
                        <Box>
                            <Typography variant="h8" gutterBottom>
                                <b>Link:</b>
                            </Typography>
                            <br></br>
                            {user["referralCode"] === "" && <>Not Generated</>}
                            {user["referralCode"] !== "" && <>
                                &nbsp;&nbsp;{path + user["referralCode"]}
                                <Button onClick={copyLinkToClipboard}><ContentCopyIcon /></Button>
                            </>}
                        </Box>
                    </Stack>
                </Box>

            </Box>
        )
    }

    const RenderReferredStatus = () => {
        const [referredStatus, setReferredStatus] = useState([])
        const getReferredStatus = async () => {
            const referredStatus = await InvokeAPI(`${getUserMgmtBase()}/v1/user/referred/info`,
                {},
                "POST",
                { "authorization": user["token"] },
                false);
            return referredStatus.response["Details"]
        }
        useEffect(() => {
            getReferredStatus().then(data => setReferredStatus(data))
        }, [])


        return (
            <>
                <Box sx={{ borderRadius: '0 0 12px 12px', overflow: 'hidden' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell
                                    sx={{
                                        borderTopLeftRadius: '12px',
                                        '&:first-of-type': {
                                            borderTopLeftRadius: '12px'
                                        }
                                    }}
                                >
                                    <b>User Email</b>
                                </StyledTableCell>
                                <StyledTableCell
                                    sx={{
                                        borderTopRightRadius: '12px',
                                        '&:last-of-type': {
                                            borderTopRightRadius: '12px'
                                        }
                                    }}
                                >
                                    <b>Count</b>
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {referredStatus.length != undefined && referredStatus.length > 0 ? (
                                referredStatus.map((user, idx) => {
                                    const isLast = idx === referredStatus.length - 1;
                                    return (
                                        <StyledTableRow key={idx}>
                                            <StyledTableCell
                                                sx={isLast ? { 
                                                    borderBottomLeftRadius: '12px',
                                                    paddingBottom: '16px',
                                                    paddingLeft: '16px'
                                                } : { paddingLeft: '16px' }}
                                            >
                                                {user.EmailId}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                sx={isLast ? { 
                                                    borderBottomRightRadius: '12px',
                                                    paddingBottom: '16px',
                                                    paddingRight: '16px'
                                                } : { paddingRight: '16px' }}
                                            >
                                                {user.Count}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })
                            ) : (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={2} sx={{ textAlign: 'center', py: 3 }}>
                                        No referrals yet
                                    </StyledTableCell>
                                </StyledTableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>

                <Stack display="none" justifyContent="center" alignItems="center">
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <h3>People you have refered so far:</h3>
                    </Box>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Card>
                            <CardContent>

                                <TableContainer >
                                    <Table sx={{ width: "auto" }}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell><b>User Email</b></StyledTableCell>
                                                <StyledTableCell><b>Activated Users</b></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {referredStatus.length != undefined && referredStatus.map((row) => (
                                                <StyledTableRow>
                                                    <StyledTableCell>{row.EmailId}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.Count}</StyledTableCell>
                                                </StyledTableRow>
                                            ))}

                                        </TableBody>
                                    </Table>
                                </TableContainer>

                            </CardContent>
                        </Card>
                    </Box>
                </Stack>
            </>
        );
    }

    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }}>
            <Stack>
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={state.open}
                    onClose={handleClose}
                    key={state.message}
                    autoHideDuration={6000}
                    TransitionProps={{ timeout: 300 }}
                >
                    <Alert 
                        variant="filled" 
                        severity={state.severity}
                        sx={{
                            animation: 'slideUp 0.3s ease-out',
                            '@keyframes slideUp': {
                                from: {
                                    opacity: 0,
                                    transform: 'translateY(-20px)',
                                },
                                to: {
                                    opacity: 1,
                                    transform: 'translateY(0)',
                                },
                            },
                        }}
                    >
                        {state.message}
                    </Alert>
                </Snackbar>
                <Box sx={{ display: "flex", justifyContent: "right", alignItems: "right", mb: 1 }}>
                    <Button variant="outlined" onClick={startTour}>
                        Take Tour
                    </Button>
                </Box>
                <Box>
                    <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12, sm: 8, md: 6 }}>
                            <Card
                                ref={inviteCardRef}
                                elevation={6}
                                sx={{ 
                                    minHeight: "300px", 
                                    borderRadius: 4, 
                                    margin: "5px",
                                    border: '1px solid',
                                    borderColor: tourOpen && tourStep === 0 ? 'primary.main' : 'divider',
                                    boxShadow: tourOpen && tourStep === 0
                                        ? '0 0 0 3px rgba(25,118,210,0.25), 0 8px 24px rgba(0,0,0,0.12)'
                                        : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                            >
                                <CardHeader 
                                    sx={{ textAlign: 'center', pb: 1 }}
                                    title={
                                        <Typography 
                                            sx={{ 
                                                fontWeight: 600,
                                                fontSize: '1.125rem',
                                                color: 'text.primary',
                                                letterSpacing: '-0.01em',
                                                textAlign: 'center',
                                                width: '100%'
                                            }} 
                                            variant="h6"
                                        >
                                            Invite via Email
                                        </Typography>
                                    } 
                                />
                                <CardContent>
                                    <InviteViaEmail />
                                </CardContent>
                            </Card>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 8, md: 6 }}>
                            <Card
                                ref={referralCardRef}
                                elevation={6}
                                sx={{ 
                                    minHeight: "300px", 
                                    borderRadius: 4, 
                                    margin: "5px",
                                    border: '1px solid',
                                    borderColor: tourOpen && tourStep === 1 ? 'primary.main' : 'divider',
                                    boxShadow: tourOpen && tourStep === 1
                                        ? '0 0 0 3px rgba(25,118,210,0.25), 0 8px 24px rgba(0,0,0,0.12)'
                                        : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                            >
                                <CardHeader 
                                    sx={{ textAlign: 'center', pb: 1 }}
                                    title={
                                        <Typography 
                                            sx={{ 
                                                fontWeight: 600,
                                                fontSize: '1.125rem',
                                                color: 'text.primary',
                                                letterSpacing: '-0.01em',
                                                textAlign: 'center',
                                                width: '100%'
                                            }} 
                                            variant="h6"
                                        >
                                            Your Referral Code Details
                                        </Typography>
                                    } 
                                />
                                <CardContent>
                                    <RenderReferralCode />
                                </CardContent>
                            </Card>
                        </Grid2>
                    </Grid2>
                    <br></br>
                    <Card
                        ref={referredCardRef}
                        elevation={6}
                        sx={{
                            borderRadius: 4, 
                            margin: "5px",
                            border: '1px solid',
                            borderColor: tourOpen && tourStep === 2 ? 'primary.main' : 'divider',
                            boxShadow: tourOpen && tourStep === 2
                                ? '0 0 0 3px rgba(25,118,210,0.25), 0 8px 24px rgba(0,0,0,0.12)'
                                : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                            overflow: 'hidden',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                                boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                transform: 'translateY(-2px)',
                            },
                        }}
                    >
                        <CardHeader 
                            sx={{ textAlign: 'center', pb: 1 }}
                            title={
                                <Typography 
                                    sx={{ 
                                        fontWeight: 600,
                                        fontSize: '1.125rem',
                                        color: 'text.primary',
                                        letterSpacing: '-0.01em',
                                        textAlign: 'center',
                                        width: '100%'
                                    }} 
                                    variant="h6"
                                >
                                    People you have referred
                                </Typography>
                            } 
                        />
                        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                            <Box sx={{ 
                                borderRadius: '0 0 16px 16px', 
                                overflow: 'hidden',
                                padding: '0 12px 12px 12px'
                            }}>
                                <RenderReferredStatus />
                            </Box>
                        </CardContent>

                    </Card>
                    <br></br>
                </Box>

                {tourOpen && (
                    <Paper
                        elevation={12}
                        sx={{
                            position: "fixed",
                            right: 24,
                            bottom: 24,
                            width: { xs: "calc(100% - 32px)", sm: 360 },
                            p: 2,
                            borderRadius: 2,
                            zIndex: 1400,
                            border: "1px solid",
                            borderColor: "divider",
                        }}
                    >
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            Section {tourStep + 1} of {tourSteps.length}: {tourSteps[tourStep].title}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                            {tourSteps[tourStep].description}
                        </Typography>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                            <Button onClick={closeTour} color="inherit">
                                Skip
                            </Button>
                            <Box sx={{ display: "flex", gap: 1 }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => goToTourStep(tourStep - 1)}
                                    disabled={tourStep === 0}
                                >
                                    Back
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => goToTourStep(tourStep + 1)}
                                >
                                    {tourStep === tourSteps.length - 1 ? "Done" : "Next"}
                                </Button>
                            </Box>
                        </Box>
                    </Paper>
                )}
            </Stack>
        </Box>
    );
};

export default Invite;